<template>
  <div class="ideas-list">
    <IdeaItem
      v-for="(item, index) in ideas"
      :item="item"
      :key="item.id"
      :hide-action="true"
      :index="index"
    />
  </div>
</template>
<script>
import IdeaItem from '@/components/types/IdeaItem'
import { mapState } from 'vuex'

export default {
  components: {
    IdeaItem,
  },
  computed: {
    ...mapState({
      ideas: (state) => state.slideOptions,
    }),
  },
}
</script>

<style lang="scss" scoped>
.ideas-list {
  margin-top: 16px;
}
</style>
